import React, { useState, useMemo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TextField,
  CircularProgress,
  Box,
  Pagination,
  Typography,
  IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const TeacherTable = ({ data = [], loading, onEdit, onDelete }) => {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const rowsPerPage = 5;

  // 🔍 Search Filter
  const filteredData = useMemo(() => {
    return data.filter((row) =>
      row.teacher_name.toLowerCase().includes(search.toLowerCase())
    );
  }, [data, search]);

  // 📌 Pagination Logic
  const paginatedData = useMemo(() => {
    const start = (page - 1) * rowsPerPage;
    return filteredData.slice(start, start + rowsPerPage);
  }, [filteredData, page]);

  return (
    <Paper
      elevation={3}
      sx={{
        padding: 2,
        marginTop: 3,
        width: "100%",
      }}
    >
      {/* Top Header */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        <Typography variant="h6">Total : {filteredData.length}</Typography>

        <TextField
          label="Search Teacher"
          size="small"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setPage(1);
          }}
        />
      </Box>

      {/* Loader */}
      {loading ? (
        <Box display="flex" justifyContent="center" py={5}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>S.no</strong>
                </TableCell>
                <TableCell>
                  <strong>Instructor Name</strong>
                </TableCell>
                <TableCell>
                  <strong>Batch Names</strong>
                </TableCell>
                <TableCell>
                  <strong>Action</strong>
                </TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {paginatedData.length > 0 ? (
                paginatedData.map((row, index) => (
                  <TableRow key={row.teacher_id}>
                    <TableCell>
                      {(page - 1) * rowsPerPage + index + 1}
                    </TableCell>

                    <TableCell>{row.teacher_name}</TableCell>

                    <TableCell>
                      {row.batches.map((b) => b.batch_name).join(", ")}
                    </TableCell>

                    <TableCell sx={{ display: "flex", gap: 1 }}>
                      {/* Edit Button */}
                      <IconButton
                        color="primary"
                        size="small"
                        onClick={() => onEdit && onEdit(row)}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>

                      {/* Delete Button */}
                      <IconButton
                        color="error"
                        size="small"
                        onClick={() => onDelete && onDelete(row)} // 🔥 delete callback
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    No Data Found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* Pagination */}
      {!loading && filteredData.length > rowsPerPage && (
        <Box display="flex" justifyContent="center" mt={2}>
          <Pagination
            count={Math.ceil(filteredData.length / rowsPerPage)}
            page={page}
            onChange={(e, value) => setPage(value)}
            color="primary"
          />
        </Box>
      )}
    </Paper>
  );
};

export default TeacherTable;
